import { postDocumentsRemindCurrentParticipants } from '../../participants/current/remind-signing';

/**
 * POST 서명 알림 재전송
 *
 * @deprecated This API is forwarded. Due to the path is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#3858988d99ab47f1993ceb652c10038f
 */
export function postDocumentsRequestReminder({
  documentId,
  workspaceId,
}: {
  documentId: string;
  workspaceId: string;
}) {
  // TODO: (standardize-document-content): 응답이 소비되는 곳이 없어 경로만 변경했는데 괜찮은지 더블체크하기
  return postDocumentsRemindCurrentParticipants({ documentId, workspaceId });
}
